<app-material [material]="false">
    <div class="header" header>
        <h2>{{ "admin.toolMaintenancePlans.recurrences.title"  | translate }}</h2>
        <app-button type="primary" class="add-button" *ngIf="!isOpen" (click)="openForm('create')">
            {{ "admin.toolMaintenancePlans.recurrences.add" | translate }}
        </app-button>
    </div>
    <ng-container body>
        <div class="body">
            <div class="list">
                <div class="list-header">
                    <app-search-bar (search)="onSearch($event)"></app-search-bar>
                </div>

                <div class="list-body" *ngIf="!(loading$ | async) || isOpen">
                    <app-recurrence *ngFor="let recurrence of recurrences"
                                    [recurrence]="recurrence"
                                    [selected]="selectedRecurrence && selectedRecurrence.id === recurrence.id"
                                    (select)="onSelectRecurrence($event)"
                                    (unselect)="onUnselectRecurrence($event)"
                    ></app-recurrence>
                    <div class="no-recurrences" *ngIf="(!(loading$ | async) || isOpen) && recurrences.length === 0">
                        <p>{{ 'admin.toolMaintenancePlans.recurrences.noRecurrences' | translate }}</p>
                    </div>
                </div>
                <app-loading-spinner class="loader" *ngIf="(loading$ | async) && !isOpen"></app-loading-spinner>

            </div>
            <div class="add-form" *ngIf="isOpen">
                <app-recurrence-details-form [loading]="(loading$ | async)"
                                             (create)="onCreateRecurrence($event)"
                                             (edit)="onEditRecurrence($event)"
                                             (delete)="onDeleteRecurrence($event)"
                                             (close)="onCloseForm()">
                </app-recurrence-details-form>
            </div>
        </div>
    </ng-container>
</app-material>

<app-confirmation-modal [confirmOnlyMode]="true"
                        [title]="'admin.toolMaintenancePlans.recurrences.deleteModal.title' | translate"
                        [question]="'admin.toolMaintenancePlans.recurrences.deleteModal.question'| translate:
                            {recurrenceName: toBeDeletedRecurrence ? toBeDeletedRecurrence.name : ''}"
                        (confirmEvent)="onConfirmDeleteRecurrence()">
</app-confirmation-modal>
